import React from "react";
import { Button } from "components/generic/kit";
import {
  Input,
  Select,
  Checkbox,
  Formik,
  Textarea,
  CustomTimePicker,
  Autocomplete
} from "components/generic/form/formik";
import {
  Row,
  Label,
  ErrorMultiple,
  ErrorBox,
  Error
} from "components/generic/form/service";
import { NarrowBody } from "components/generic/layout";
import { Overlay } from "components/common/insider";
import { Days } from "core/utils/constants";
import { Timezone } from "core/utils";
import { FieldArray } from "formik";

export default ({
  roles,
  fetchRoles,
  tags,
  fetchGroupTags,
  companies,
  cities,
  onCountriesChange,
  fetchCompanies,
  validationSchema,
  onSignInSuccess,
  onSubmit,
  signUpApi,
  linkedInSignInApi,
  school,
  submitApi,
  countries,
  initialValues,
  offer,
  errors
}) => (
  <Overlay>
    <NarrowBody>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        errors={errors.field}
      >
        {props => (
          <React.Fragment>
            <form onSubmit={props.handleSubmit}>
              {!!errors.nonField.length && (
                <ErrorBox errors={errors.nonField} />
              )}

              <h2 className="pl2">General Information</h2>
              <div className=" pl4-ns">
                <Row>
                  <Label title="Write down a short description about you">
                    <div className="measure">
                      <Textarea
                        name="resume"
                        placeholder="Enter description here"
                        rows="6"
                      />
                    </div>
                  </Label>
                </Row>
                <Row>
                  <Label title="LinkedIn Profile URL(optional)">
                    <Input
                      name="linkedin_url"
                      type="text"
                      placeholder="Enter your linkedin url"
                    />
                  </Label>
                </Row>
                <Row>
                  <Checkbox
                    name="target_school"
                    title="Please check the box if you broke into investment banking through a formal on-campus recruiting program"
                  />
                </Row>
              </div>
              <h2 className="pl2 pv2">Professional experience</h2>
              {submitApi.error &&
                submitApi.error.positions &&
                submitApi.error.positions.length > 0 && (
                  <div className="mb3 measure">
                    <ErrorMultiple errors={submitApi.error.positions} />
                  </div>
                )}

              <Row>
                <FieldArray name="positions">
                  {arrayHelpers => (
                    <React.Fragment>
                      {props.values.positions &&
                        props.values.positions.length > 0 &&
                        props.values.positions.map((positions, index) => (
                          <div
                            className="flex-ns flex-column ba b--black-20 br3 pa3 mb2"
                            key={index}
                          >
                            <Row>
                              <Label title="Company">
                                <Autocomplete
                                  id="company"
                                  name={`positions.${index}.company_name`}
                                  onType={fetchCompanies}
                                  inputProps={{
                                    placeholder: "Enter company name"
                                  }}
                                  items={companies}
                                  getItemValue={item => item.title}
                                  renderItem={(item, isHighlighted) => (
                                    <div
                                      key={item.id}
                                      style={{
                                        background: isHighlighted
                                          ? "lightgray"
                                          : "white"
                                      }}
                                    >
                                      {item.title}
                                    </div>
                                  )}
                                />
                              </Label>
                            </Row>
                            <Row>
                              <Label title="Role">
                                <Autocomplete
                                  id="role"
                                  name={`positions.${index}.title_name`}
                                  onType={fetchRoles}
                                  inputProps={{
                                    placeholder: "Enter your role"
                                  }}
                                  items={roles}
                                  getItemValue={item => item.title}
                                  renderItem={(item, isHighlighted) => (
                                    <div
                                      key={item.id}
                                      style={{
                                        background: isHighlighted
                                          ? "lightgray"
                                          : "white"
                                      }}
                                    >
                                      {item.title}
                                    </div>
                                  )}
                                />
                              </Label>
                            </Row>
                            <Row>
                              <Label title="group tag">
                                <Autocomplete
                                  id="group_tag_label"
                                  name={`positions.${index}.group_tag_label`}
                                  onType={fetchGroupTags}
                                  inputProps={{
                                    placeholder:
                                      "Enter tag related to your position"
                                  }}
                                  items={tags}
                                  getItemValue={item => item.title}
                                  renderItem={(item, isHighlighted) => (
                                    <div
                                      key={item.id}
                                      style={{
                                        background: isHighlighted
                                          ? "lightgray"
                                          : "white"
                                      }}
                                    >
                                      {item.title}
                                    </div>
                                  )}
                                />
                              </Label>
                            </Row>
                            <Row>
                              <Label title="Country">
                                <Select
                                  onSelect={e => {
                                    onCountriesChange(
                                      index,
                                      countries.data.countries.find(
                                        c => c.name === e.target.value
                                      )
                                    );
                                  }}
                                  name={`positions.${index}.country`}
                                >
                                  <option key="" value="">
                                    Choose a country
                                  </option>
                                  {countries.data.countries &&
                                    countries.data.countries.map((item, i) => (
                                      <option key={i} value={item.code2}>
                                        {item.name}
                                      </option>
                                    ))}
                                </Select>
                              </Label>
                            </Row>
                            <Row>
                              <Select name={`positions.${index}.city`}>
                                <option key="" value="">
                                  Choose a city
                                </option>
                                {cities[index] &&
                                  cities[index].map((item, i) => (
                                    <option key={i} value={item}>
                                      {item}
                                    </option>
                                  ))}
                              </Select>
                            </Row>
                            <Row>
                              <Checkbox
                                name={`positions.${index}.is_main_position`}
                                title="This is my current position"
                              />
                            </Row>
                            <div className="flex">
                              <div className="pa2">
                                <Button
                                  type="button"
                                  color="green"
                                  size="small"
                                  onClick={() =>
                                    arrayHelpers.push({
                                      company_name: "",
                                      title_name: "",
                                      group_tag_label: "",
                                      is_main_position: false
                                    })
                                  }
                                >
                                  + Add position
                                </Button>
                              </div>
                              <div className="pa2">
                                <Button
                                  type="button"
                                  color="lightRed"
                                  size="small"
                                  onClick={() => arrayHelpers.remove(index)}
                                >
                                  X Remove
                                </Button>
                              </div>
                            </div>
                          </div>
                        ))}

                      {props.values.positions.length === 0 && (
                        <div
                          className="pointer fw6 pl3"
                          onClick={() =>
                            arrayHelpers.push({
                              company_name: "",
                              title_name: "",
                              group_tag_label: "",
                              is_main_position: false
                            })
                          }
                        >
                          + Add position
                        </div>
                      )}
                    </React.Fragment>
                  )}
                </FieldArray>
              </Row>
              <h2 className="pl2 pv2">Insider Availabilities</h2>
              {submitApi.error &&
                submitApi.error.availabilities &&
                submitApi.error.availabilities.length > 0 && (
                  <div className="mb3 measure">
                    <ErrorMultiple errors={submitApi.error.availabilities} />
                  </div>
                )}
              <Row>
                <FieldArray name="availabilities">
                  {arrayHelpers => (
                    <React.Fragment>
                      {props.values.availabilities &&
                        props.values.availabilities.length > 0 &&
                        props.values.availabilities.map(
                          (availabilities, index) => (
                            <div
                              className="flex-ns flex-column ba b--black-20 br3 pa3 mb2"
                              key={index}
                            >
                              <Row className="pl3">
                                <Label title="Availability Day">
                                  <Select
                                    name={`availabilities.${index}.day`}
                                    type="select"
                                  >
                                    <option key="" value="" />
                                    {Days.map((i, index) => (
                                      <option key={index} value={i.value}>
                                        {i.name}
                                      </option>
                                    ))}
                                  </Select>
                                </Label>
                              </Row>
                              <Row className="pl3">
                                <Label title="Timezone">
                                  <Select
                                    name={`availabilities.${index}.time_zone`}
                                    type="select"
                                  >
                                    <option value="America/New_York">
                                      America/New_York
                                    </option>
                                    {Timezone.map((i, index) => (
                                      <option key={index} value={i}>
                                        {i}
                                      </option>
                                    ))}
                                  </Select>
                                </Label>
                              </Row>
                              <Row className="pl3">
                                <Label title="Time Start">
                                  <CustomTimePicker
                                    name={`availabilities.${index}.time_start`}
                                  />
                                </Label>
                              </Row>
                              <Row className="pl3">
                                <Label title="Time End">
                                  <CustomTimePicker
                                    name={`availabilities.${index}.time_end`}
                                  />
                                </Label>
                              </Row>
                              <div className="pl3 flex">
                                <div className="pa2">
                                  <Button
                                    type="button"
                                    color="green"
                                    size="small"
                                    onClick={() =>
                                      arrayHelpers.push({
                                        day: "",
                                        time_zone:
                                          Intl.DateTimeFormat().resolvedOptions()
                                            .timeZone || "America/New_York",
                                        time_start: "",
                                        time_end: ""
                                      })
                                    }
                                  >
                                    + Add availability
                                  </Button>
                                </div>
                                <div className="pa2">
                                  <Button
                                    type="button"
                                    color="lightRed"
                                    size="small"
                                    onClick={() => arrayHelpers.remove(index)}
                                  >
                                    X Remove
                                  </Button>
                                </div>
                              </div>
                            </div>
                          )
                        )}

                      {props.values.availabilities.length === 0 && (
                        <div
                          className="pointer pl3 fw6"
                          onClick={() =>
                            arrayHelpers.push({
                              day: "",
                              time_zone:
                                Intl.DateTimeFormat().resolvedOptions()
                                  .timeZone || "America/New_York",
                              time_start: "",
                              time_end: ""
                            })
                          }
                        >
                          + Add availability
                        </div>
                      )}
                      {submitApi.error &&
                        submitApi.error.message && (
                          <Error> {submitApi.error.message} </Error>
                        )}
                      <div className="mt3 pa3 flex items-center">
                        <Button type="submit">Submit</Button>
                        <p className="pl2 f7 pt1">
                          By clicking "Submit", you agree to our{" "}
                          <a
                            href="https://thelobby.io/legal/terms"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="link"
                          >
                            Terms &amp; Conditions
                          </a>{" "}
                          and that you have read our{" "}
                          <a
                            href="https://thelobby.io/legal/privacy"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="link"
                          >
                            Privacy Policy
                          </a>{" "}
                        </p>
                      </div>
                    </React.Fragment>
                  )}
                </FieldArray>
              </Row>
            </form>
          </React.Fragment>
        )}
      </Formik>
    </NarrowBody>
  </Overlay>
);



// WEBPACK FOOTER //
// ./src/components/pages/Insider/ProfileSetup/View.js